import UserAppContext from "../../hook/UserAppContext"
import Friends from '../../components/friend/Friends'
import SocialMenu from '../../components/social/SocialMenu'

const Home = ({isCurrent}) => {

      const {user} = UserAppContext()
      const {infordata, friends, social, banners} = user.user 

      if(isCurrent !== 'home') return

      return (
            <div className={isCurrent === 'home' ? "wrapper_page show" : "wrapper_page"}>
                  <div className="page_home__content">
                        <h1>{banners.data ? "Welcome to my xatspace!" : banners[0].title}</h1>
                        <div className="page_home_description">
                              <p>{infordata.about}</p>
                        </div>
                        <div className="friend_content">
                              <Friends friends={friends} />
                        </div>
                        <SocialMenu social={social} />
                  </div>
            </div>
      )
}

export default Home
